const ytNumber = (number) => {
    if(number < 1000) return number
    if(1000 <= number && number < 1000000) return `${Math.round(number) / 1000}K`
    if(1000000 <= number ) return `${Math.round(number) / 1000000}M`
}
export default ytNumber


// WEBPACK FOOTER //
// ./src/dev/validation/YouTubeNumber.js